<template>
    <v-dialog v-model="modalProp" max-width="1300">
        <v-card>
            <v-card-title class="white">
                <v-row>
                    <div class="col-10" style="font-size:small;">
                        <span class="green--text"> <b>{{ doctor }}</b></span>
                    </div>
                    <div class="col-2 d-flex justify-end">
                        <v-btn icon @click="modalProp = false">
                            <v-icon>{{ mdiClose }}</v-icon>
                        </v-btn>
                    </div>
                </v-row>
            </v-card-title>
            <v-divider />
            <v-data-table
                :headers="headers"
                :items="doctorData"
                :items-per-page="5"
                :footer-props="{
                    'items-per-page-options': [5, 10, 15, -1],
                    'items-per-page-text': ''
                }"
            />
        </v-card>
    </v-dialog>
</template>

<script>
import { mdiClose } from '@mdi/js'

export default {
    props: [
        'doctor',
        'doctorData',
        'show'
    ],
    data() {
        return {
            mdiClose,
            headers: [
                {
                    text: 'Hospital',
                    sortable: true,
                    value: 'hosp_name'
                },
                {
                    text: 'Schedule',
                    sortable: true,
                    value: 'af_sched'
                },
                {
                    text: 'Room Number',
                    sortable: true,
                    value: 'af_roomno'
                },
                {
                    text: 'Address',
                    sortable: true,
                    value: 'hosp_address'
                }
            ]
        }
    },
    computed: {
        modalProp: {
            get() {
                return this.show
            },
            set(val) {
                this.$emit('showDialog', val)
            }
        }
    }
}
</script>
